import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/questionnaireList';

/**
 * アンケート一覧画面のState型
 */
export interface IQuestionnaireListState {
	readonly items: Actions.IQuestionnaire[];
}

/**
 * アンケート一覧画面のState初期値
 */
const initialState: IQuestionnaireListState = {
	items: [],
};

/**
 * アンケート一覧画面用reducer
 * @param state State
 * @param action アクション
 */
const questionnaire = (state: IQuestionnaireListState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setItems)) {
		return {
			...state,
			items: action.payload.items,
		};
	}

	if (isType(action, Actions.clearQuestionnaireParams)) {
		return initialState;
	}

	return state;
};

export default questionnaire;



// WEBPACK FOOTER //
// ./src/reducers/QuestionnaireList.ts